import { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";


function Contact() {
  const form = useRef();

  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    message: "",
  });

  /* =====================================================
     OPEN CONTACT PAGE DIRECTLY AT FORM
  ===================================================== */
  useEffect(() => {
    const timer = setTimeout(() => {
      const formSection = document.getElementById("contact-form");

      if (formSection) {
        formSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 250);

    return () => clearTimeout(timer);
  }, []);

  /* =====================================================
     FORM CHANGE
  ===================================================== */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setSuccess("");
    setError("");
  };

  /* =====================================================
     SUBMIT FORM
  ===================================================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    setSending(true);
    setSuccess("");
    setError("");

    try {
      /* ================================================
         EMAILJS
      ================================================= */

      await emailjs.sendForm(
        "service_5j3eygd",
        "template_9soti6a",
        form.current,
        {
          publicKey: "bsy-x9YuZROhrGgW3",
        }
      );

      /* ================================================
         WHATSAPP MESSAGE
      ================================================= */

      const whatsappMessage = `
New Appointment Enquiry 💄

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Service: ${formData.service}
Preferred Date: ${formData.date || "Not specified"}

Message:
${formData.message || "No message provided"}
      `.trim();

      const whatsappNumber = "918595644307";

      const whatsappURL =
        `https://wa.me/${whatsappNumber}?text=` +
        encodeURIComponent(whatsappMessage);

      /* ================================================
         OPEN WHATSAPP
      ================================================= */

      window.open(whatsappURL, "_blank");

      /* ================================================
         SUCCESS
      ================================================= */

      setSuccess(
        "Your enquiry has been sent successfully. WhatsApp is ready with the enquiry."
      );

      /* ================================================
         RESET
      ================================================= */

      setFormData({
        name: "",
        email: "",
        phone: "",
        service: "",
        date: "",
        message: "",
      });

    } catch (err) {
      console.error("EmailJS Error:", err);

      setError(
        "Something went wrong while sending your enquiry. Please try again."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-page">

      {/* =====================================================
          CONTACT MAIN
      ===================================================== */}

      <section className="contact-main">

        <div className="contact-container">

          {/* =====================================================
              LEFT SIDE - CONTACT INFORMATION
          ===================================================== */}

          <div className="contact-info">

            <span className="contact-small-title">
              CONTACT US
            </span>


            <h2>
              Your beauty
              <br />
              <em>starts here.</em>
            </h2>


            <p className="contact-description">
              Have a question, want to book an appointment,
              or simply want to know more about our services?
              Send us a message and we'll get back to you.
            </p>


            {/* =====================================================
                EMAIL
            ===================================================== */}

            <a
              href="mailto:aggarwalt426@gmail.com"
              className="contact-detail"
            >

              <span className="contact-icon contact-email-icon">

                <svg viewBox="0 0 24 24">

                  <rect
                    x="3"
                    y="5"
                    width="18"
                    height="14"
                    rx="2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <path
                    d="m4 7 8 6 8-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                </svg>

              </span>


              <span className="contact-detail-text">

                <small>
                  EMAIL
                </small>

                <strong>
                  aggarwalt426@gmail.com
                </strong>

              </span>

            </a>


            {/* =====================================================
                WHATSAPP 1
            ===================================================== */}

            <a
              href="https://wa.me/918595644307"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-detail"
            >

              <span className="contact-icon contact-whatsapp-icon">

                <svg viewBox="0 0 24 24">

                  <path
                    d="M20.5 11.2a8.5 8.5 0 0 1-12.7 7.4L4 20l1.5-3.6A8.5 8.5 0 1 1 20.5 11.2z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <path
                    d="M8.5 8.5c.3-.5.6-.5.9-.5h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4 0 .6l-.5.7c-.1.2-.1.4 0 .6.5.9 1.3 1.6 2.2 2.1.2.1.4.1.6-.1l.7-.8c.2-.2.4-.2.7-.1l1.5.7c.3.1.4.3.4.5v.5c0 .3-.1.6-.4.8-.4.3-1 .5-1.6.4-1.1-.2-2.4-.9-3.6-2.1-1.2-1.2-1.9-2.4-2.1-3.5-.1-.6.1-1.2.5-1.8z"
                    fill="currentColor"
                  />

                </svg>

              </span>


              <span className="contact-detail-text">

                <small>
                  WHATSAPP
                </small>

                <strong>
                  +91 85956 44307
                </strong>

              </span>

            </a>


            {/* =====================================================
                WHATSAPP 2
            ===================================================== */}

            <a
              href="https://wa.me/917834923166"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-detail"
            >

              <span className="contact-icon contact-whatsapp-icon">

                <svg viewBox="0 0 24 24">

                  <path
                    d="M20.5 11.2a8.5 8.5 0 0 1-12.7 7.4L4 20l1.5-3.6A8.5 8.5 0 1 1 20.5 11.2z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <path
                    d="M8.5 8.5c.3-.5.6-.5.9-.5h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4 0 .6l-.5.7c-.1.2-.1.4 0 .6.5.9 1.3 1.6 2.2 2.1.2.1.4.1.6-.1l.7-.8c.2-.2.4-.2.7-.1l1.5.7c.3.1.4.3.4.5v.5c0 .3-.1.6-.4.8-.4.3-1 .5-1.6.4-1.1-.2-2.4-.9-3.6-2.1-1.2-1.2-1.9-2.4-2.1-3.5-.1-.6.1-1.2.5-1.8z"
                    fill="currentColor"
                  />

                </svg>

              </span>


              <span className="contact-detail-text">

                <small>
                  WHATSAPP
                </small>

                <strong>
                  +91 78349 23166
                </strong>

              </span>

            </a>


            {/* =====================================================
                LOCATION
            ===================================================== */}

            <div className="contact-detail">

              <span className="contact-icon contact-location-icon">

                <svg viewBox="0 0 24 24">

                  <path
                    d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <circle
                    cx="12"
                    cy="10"
                    r="2.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                </svg>

              </span>


              <span className="contact-detail-text">

                <small>
                  LOCATION
                </small>

                <strong>
                  India, Delhi
                </strong>

              </span>

            </div>


            {/* =====================================================
                INSTAGRAM
            ===================================================== */}

            <a
              href="https://www.instagram.com/tanyaaggarwalmakeup?stkn=czZrdjRhejBuMnp6&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-detail"
            >

              <span className="contact-icon contact-instagram-icon">

                <svg viewBox="0 0 24 24">

                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <circle
                    cx="12"
                    cy="12"
                    r="4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <circle
                    cx="17.5"
                    cy="6.5"
                    r="1"
                    fill="currentColor"
                  />

                </svg>

              </span>


              <span className="contact-detail-text">

                <small>
                  INSTAGRAM
                </small>

                <strong>
                  @tanyaaggarwalmakeup
                </strong>

              </span>

            </a>


            {/* =====================================================
                YOUTUBE
            ===================================================== */}

            <a
              href="https://youtube.com/@tanyaaggarwal1399?si=E_XEtkCIokXBG9x9"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-detail"
            >

              <span className="contact-icon contact-youtube-icon">

                <svg viewBox="0 0 24 24">

                  <path
                    d="M21.5 7.2a2.8 2.8 0 0 0-2-2C17.8 4.7 12 4.7 12 4.7s-5.8 0-7.5.5a2.8 2.8 0 0 0-2 2C2 8.9 2 12 2 12s0 3.1.5 4.8a2.8 2.8 0 0 0 2 2c1.7.5 7.5.5 7.5.5s5.8 0 7.5-.5a2.8 2.8 0 0 0 2-2c.5-1.7.5-4.8.5-4.8s0-3.1-.5-4.8z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                  />

                  <path
                    d="M10 15.5 15 12l-5-3.5v7z"
                    fill="currentColor"
                  />

                </svg>

              </span>


              <span className="contact-detail-text">

                <small>
                  YOUTUBE
                </small>

                <strong>
                  @tanyaaggarwal1399
                </strong>

              </span>

            </a>

          </div>


          {/* =====================================================
              RIGHT SIDE - FORM
              IMPORTANT:
              contact-form ID IS HERE
          ===================================================== */}

          <div
            className="contact-form-wrapper"
            id="contact-form"
          >

            {/* ===================================================
                FORM HEADER
            =================================================== */}

            <div className="contact-form-header">

              <span>
                BOOK AN APPOINTMENT
              </span>


              <h3>
                Tell us about
                <br />
                <em>your requirements.</em>
              </h3>

            </div>


            {/* ===================================================
                FORM
            =================================================== */}

            <form
              ref={form}
              className="contact-form"
              onSubmit={handleSubmit}
            >

              {/* =================================================
                  NAME + EMAIL
              ================================================= */}

              <div className="contact-form-row">

                <div className="contact-field">

                  <label>
                    YOUR NAME
                  </label>

                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />

                </div>


                <div className="contact-field">

                  <label>
                    EMAIL ADDRESS
                  </label>

                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />

                </div>

              </div>


              {/* =================================================
                  PHONE + SERVICE
              ================================================= */}

              <div className="contact-form-row">

                <div className="contact-field">

                  <label>
                    PHONE NUMBER
                  </label>

                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 XXXXX XXXXX"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />

                </div>


                <div className="contact-field">

                  <label>
                    SERVICE
                  </label>

                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >

                    <option value="">
                      Select a service
                    </option>

                    <option value="Bridal Makeup">
                      Bridal Makeup
                    </option>

                    <option value="Party Makeup">
                      Party Makeup
                    </option>

                    <option value="Makeup Artist">
                      Makeup Artist
                    </option>

                    <option value="Beauty Consultation">
                      Beauty Consultation
                    </option>

                    <option value="Skincare">
                      Skincare
                    </option>

                    <option value="Other">
                      Other
                    </option>

                  </select>

                </div>

              </div>


              {/* =================================================
                  DATE
              ================================================= */}

              <div className="contact-field">

                <label>
                  PREFERRED DATE
                </label>

                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                />

              </div>


              {/* =================================================
                  MESSAGE
              ================================================= */}

              <div className="contact-field">

                <label>
                  YOUR MESSAGE
                </label>

                <textarea
                  name="message"
                  rows="5"
                  placeholder="Tell us what you're looking for..."
                  value={formData.message}
                  onChange={handleChange}
                />

              </div>


              {/* =================================================
                  SUBMIT BUTTON
              ================================================= */}

              <button
                type="submit"
                className="contact-submit"
                disabled={sending}
              >

                <span>
                  {sending
                    ? "SENDING..."
                    : "SEND ENQUIRY"}
                </span>

                <span className="contact-submit-arrow">
                  →
                </span>

              </button>


              {/* =================================================
                  SUCCESS MESSAGE
              ================================================= */}

              {success && (
                <p className="contact-success">
                  {success}
                </p>
              )}


              {/* =================================================
                  ERROR MESSAGE
              ================================================= */}

              {error && (
                <p className="contact-error">
                  {error}
                </p>
              )}

            </form>

          </div>

        </div>

      </section>

    </div>
  );
}

export default Contact;